<img *ngIf="image != 'no-image'" style="height: 100%;width: 100%;" [src]="image">
<div class="row text-center" *ngIf="image == 'no-image'" style="margin-top: 15%;font-size: 35px;">
    <div class="col">
        No image for found!
    </div>
</div>